const SlickprevCircle = ({ ...props }) => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
            <circle cx="20" cy="20" r="20" fill="black" />
            <path
                d="M22.6318 26.2632L16.0003 19.6316L22.6318 13"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default SlickprevCircle
